module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-SemiBoldItalic-WebXL-05662cc88bf348c9c31502743fbce5dc.woff2";